// apps/web/src/main.tsx
import './app.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('[Chat Web] Root element #root not found in DOM');
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
